import React, { useState, useEffect } from 'react';
import { Spinner } from 'reactstrap';
import { v4 as generateUnid } from 'uuid';
import moment from 'moment';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import getConcessionsApi from '../../services/Form/getConcessionsApi';
import '../../assets/scss/react-datepicker.css';
import useLocalStorage from '../../hooks/useLocalStorage/useLocalStorage';
import mapStateToProps from '../../Store/mapping/record/mapStateToProps';
import mapDispatchToProps from '../../Store/mapping/record/mapDispatchToProps';
import { Auth } from '../../config/configuration/react';

function generateRefHexaId() {
  const uuid1 = generateUnid();
  return uuid1.substring(0, 7).toUpperCase();
}

const CreateFile = ({ putInitRecord }) => {
  const userId = Auth.userId();
  let date = moment().format('YYYY-MM-DD');
  let time = moment().hours();
  if (time < '09' || time > '19') {
    if (time > '19') date = moment().add(1, 'days').format('YYYY-MM-DD');
    time = '09';
  }
  const initRecord = {
    details: {
      record: {
        id: 0,
        refHexaId: generateRefHexaId(),
        refId: parseInt(generateRefHexaId(), 16),
        statusId: 0,
        recordTypeId: 1,
      },
      appointment: {
        appointmentDateTime: `${date} ${time}:00`,
      },
      carcheckPointOfSale: {},
    },
    recordId: 0,
    statusCarcheck: 0,
    buyerId: userId,
    carcheckPointOfSale: null,
  };
  const [defaultPointOfSale, setDefaultPointOfSale] = useLocalStorage(`${userId}.defaultPointOfSale`, null);
  const [done, setDone] = useState(false);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (!defaultPointOfSale && !Auth.roleViewerAccess()) {
      getConcessionsApi().then((concessions) => {
        setDefaultPointOfSale(concessions[0]);
      });
    }
  }, []);

  useEffect(() => {
    if (!defaultPointOfSale || Auth.roleViewerAccess()) return;
    initRecord.carcheckPointOfSale = defaultPointOfSale.id;
    initRecord.details.carcheckPointOfSale = defaultPointOfSale;
    putInitRecord(initRecord.details);
    setDone(true);
  }, [defaultPointOfSale]);

  useEffect(() => {
    const defaultPof = window.localStorage.getItem(`${userId}.defaultPointOfSale`);
    if (defaultPof) {
      setRedirect(true);
    } else {
      setRedirect(false);
    }

    setDone(false);
  });

  if (done) return <Spinner />;
  return (
    <>
      {(redirect || Auth.roleViewerAccess()) && (
        <Redirect
          to={{
            pathname: '/files/0',
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateFile);

CreateFile.propTypes = {
  putInitRecord: PropTypes.func.isRequired,
};
